module.exports = __webpack_public_path__ + "img/logo.eb90bec7.png";